export default function FormSchemaContent() {
  return (
    <div>
      <section className="mb-8">
        <p className="mb-4">
          Forms define the structure of CaseFiles and specify which data should
          be collected for different legal matters. They are associated with
          AreasOfLaw and CaseTypes, and can include custom fields, sections,
          tabs, entity schemas, and localized display text.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          CaseFile Creation Process
        </h2>
        <ol className="list-decimal pl-6 mb-4">
          <li>
            Get the active AreasOfLaw for a LawFirm to discover available Forms.
          </li>
          <li>Choose an appropriate Form for the case type.</li>
          <li>
            Include the selected <code>formId</code> when creating a CaseFile.
          </li>
          <li>
            Populate the CaseFile and related entities with data that complies
            with the Form's entity schemas and custom field definitions.
          </li>
        </ol>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          Key Components of a Form
        </h2>

        <h3 className="text-xl font-semibold mb-2">1. Form Sections</h3>
        <p className="mb-4">
          Form sections organize the CaseFile into logical groups of
          information. Each section can contain multiple custom fields and may
          be associated with a specific EntitySchema.
        </p>

        <h3 className="text-xl font-semibold mb-2">2. EntitySchemas</h3>
        <p className="mb-4">
          EntitySchemas define the structure for specific types of data within a
          CaseFile, such as client information, opposing parties, insurances, or
          case-specific details. They determine which CustomFields are available
          for each entity type.
        </p>

        <h3 className="text-xl font-semibold mb-2">3. CustomFields</h3>
        <p className="mb-4">
          CustomFields are the individual data points collected within a
          CaseFile. They can be of various types:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Short Text</li>
          <li>Long Text</li>
          <li>Number</li>
          <li>Date</li>
          <li>Options (single or multiple choice)</li>
          <li>File Upload</li>
        </ul>
        <p className="mb-4">
          Each CustomField can have its own validation rules and display
          options.
        </p>
      </section>
    </div>
  );
}
